import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Radio,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const rightBorder = {
  borderRight: 1,
  borderRightColor: "divider",
};
const bottomBorder = {
  borderBottom: 1,
  borderBottomColor: "divider",
};
export const ProductMultiVariantTable = ({
  variants = [],
  tenantPreferredLanguages = [],
  regionState,
  handleDefaultVariant,
  handleModal,
  isDisabled,
  onCreate,
}) => {
  const languages = tenantPreferredLanguages.map((language) => {
    const code = typeof language === "string" ? language : language.code;
    const option = regionState?.languagesOptions?.find(
      (item) => item.code === code,
    );

    return { code, name: option?.name || code };
  });

  return (
    <Card
      sx={{
        mb: "24px",
        // border: "1px solid #e5e7eb",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: "24px", borderBottom: "1px solid #e5e7eb" }}
      >
        <Typography fontSize="16px" fontWeight={600}>
          Product Variants
        </Typography>
        <Button
          type="button"
          size="medium"
          variant="text"
          startIcon={<Add />}
          onClick={onCreate}
          disabled={isDisabled}
        >
          Create
        </Button>
      </Stack>
      <Box sx={{ overflowX: "auto" }}>
        <Table
          sx={{
            minWidth: "760px",
            borderCollapse: "collapse",
            "& .MuiTableCell-root": {
              py: "10px",
            },
            "& .MuiTableHead-root .MuiTableCell-root": {
              backgroundColor: "#f3f4f6",
              fontWeight: 600,
              whiteSpace: "nowrap",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={rightBorder}>Languages</TableCell>
              <TableCell sx={rightBorder}>Name</TableCell>
              <TableCell sx={rightBorder}>PLU Code</TableCell>
              <TableCell>Old PLU Code</TableCell>
              <TableCell align="center">Default</TableCell>
              <TableCell align="right">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {variants.map((variant, index) => {
              const rowSpan = languages.length + 1;
              const localeNames = variant.locale_name || {};

              return (
                <React.Fragment key={variant.id}>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        ...rightBorder,
                      }}
                    >
                      Variant {index + 1}
                    </TableCell>
                    <TableCell sx={rightBorder} />
                    <TableCell
                      rowSpan={rowSpan}
                      sx={{
                        borderBottom: variants.length === index + 1 ? 0 : 1,
                        borderBottomColor: "divider",
                        ...rightBorder,
                      }}
                    >
                      {variant.plu}
                    </TableCell>
                    <TableCell
                      rowSpan={rowSpan}
                      sx={{
                        borderBottom: variants.length === index + 1 ? 0 : 1,
                        borderBottomColor: "divider",
                      }}
                    >
                      {variant.old_plu}
                    </TableCell>
                    <TableCell align="center">
                      <Radio
                        checked={Boolean(variant.default_variant)}
                        value={variant.id}
                        onClick={() => {
                          if (!variant.default_variant) {
                            handleDefaultVariant(variant.id);
                          }
                        }}
                        name="radio-buttons"
                        sx={{ p: "3.5px" }}
                      />
                    </TableCell>
                    <TableCell align="start">
                      <div className="action-buttons">
                        <img
                          alt="delete"
                          onClick={() =>
                            handleModal("varient-delete", true, variant.id)
                          }
                          src="/icons/ic_delete.svg"
                        />
                        <img
                          alt="edit"
                          onClick={() =>
                            handleModal("varient-edit", true, variant.id)
                          }
                          src="/icons/ic_edit.svg"
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                  {languages.map((language, languageIndex) => {
                    const borderStyle =
                      index === variants.length - 1 &&
                      languageIndex === languages.length - 1
                        ? rightBorder
                        : {
                            ...rightBorder,
                            ...bottomBorder,
                          };
                    return (
                      <TableRow
                        key={`${variant.id}-${language.code}`}
                        sx={
                          languageIndex === languages.length - 1 &&
                          index !== variants.length - 1
                            ? bottomBorder
                            : {}
                        }
                      >
                        <TableCell sx={borderStyle}>{language.name}</TableCell>
                        <TableCell sx={borderStyle}>
                          {localeNames[language.code] ||
                            (languageIndex === 0 ? variant.name : "")}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Card>
  );
};
